// extracted by mini-css-extract-plugin
export default {"button":"Copy_button__FOP23"};